export default __webpack_public_path__ + "static/media/1589-thesmarmybum.e039f9e4.pdf";